import { Icon } from 'ui/components/primitives';
import { slugify } from 'core/utilities/strings/slugify';

import { Step, StepLink } from './Breadcrumbs.components.styles';
import type { TrailProps } from './Breadcrumbs.components';

const TrailBase = ({ disabled, trailSteps = [], currentSection }: TrailProps): JSX.Element => {
  const trackBreadcrumb = (name: string) => {
    window.dataLayer.push({
      event: 'analytics-event',
      event_parameters: {
        cd_section: slugify(currentSection),
        event_name: 'interaction_breadcrumb',
        cd_interaction_detail: slugify(`click:${name}`),
      },
    });
  };

  return (
    <>
      {trailSteps.map(({ name, url }) => (
        <Step key={name}>
          <Icon.ArrowRight size="m" />
          <StepLink
            data-disabled={disabled}
            to={{
              pathname: url,
              state: {
                pathTitle: name,
                pathQueryTitle: url,
              },
            }}
          >
            <span
              tabIndex={0}
              aria-label={`clique para ir para ${name}`}
              onClick={() => trackBreadcrumb(name)}
            >
              {name}
            </span>
          </StepLink>
        </Step>
      ))}
    </>
  );
};

export default TrailBase;
